import React from "react"
import ProductImages from "./ProductImages"
import ProductDetails from "./ProductDetails"

const ProoductDetailsSection = ({data, ratings, isLoading}) => {

    const images = data?.media;
    return (
        <React.Fragment>
            <section className="grid grid-cols-1 lg:grid-cols-2 px-0 lg:px-4">
                <div className="col-span-1 relative lg:sticky top-0 lg:top-16 h-auto lg:h-screen z-0">
                    <ProductImages images={images} />
                </div>

                <div className="col-span-1 relative">
                    <ProductDetails data={data} ratings={ratings} isLoading={isLoading} />
                </div>
            </section>
        </React.Fragment>
    )
}

export default ProoductDetailsSection